/* eslint-disable react-hooks/exhaustive-deps */
import { memo, useEffect, useRef } from "react"
import { CSVLink } from "react-csv"
// import { DownloadIcon } from "../images/svgs"
import { Download } from "../../images/drawer/light"
import { RotatingLines } from "react-loader-spinner"

// import GlobalButton from "./Global/GlobalButton"
// import { useTranslation } from 'react-i18next';

type TGetCSVData = {
    onclick: () => void
    transactionData: any
    disabled: boolean
    onDownloadReady: () => void
    fileName?: string
    classes?: string
    loading?: boolean
}

const GetCSVData = ({
    onclick,
    transactionData,
    disabled,
    onDownloadReady,
    fileName = "transactions.csv",
    classes,
    loading = false,
}: TGetCSVData) => {
    const csvLink = useRef<any>(null)

    //   const { t } = useTranslation();

    useEffect(() => {
        if (transactionData.length > 0) {
            onDownloadReady()

            csvLink.current.link.click()
        }
    }, [transactionData])

    return (
        <div className={classes}>
            <button
                type="button"
                disabled={disabled}
                onClick={onclick}
                className="flex items-center justify-center gap-2 bg-primaryOrange hover:bg-orange-300 disabled:bg-orange-300 text-white font-medium text-sm py-2.5 px-5 w-36 rounded-lg transition-colors duration-200"
            >
                {loading ? (
                    <div className="flex items-center gap-2">
                        <RotatingLines
                            visible={true}
                            width="20"
                            strokeWidth="3"
                            animationDuration="0.75"
                            strokeColor="white"
                        />
                    </div>
                ) : (
                    <div className="flex items-center gap-2">
                        <img
                            src={Download}
                            alt="download"
                            width={16}
                            height={16}
                        />
                        <span>Download</span>
                    </div>
                )}
            </button>
            <CSVLink
                data={transactionData}
                filename={fileName}
                className="hidden"
                ref={csvLink}
                target="_blank"
            />
        </div>
    )
}

export default memo(GetCSVData)
